import { MODAL_CONFIG } from "../../../config/modal.config";
import { Icon } from "../../index";
import { RiCloseLine } from "react-icons/ri";
import React from "react";
import { Modal } from "antd";
import { ntbLogo } from "../../../assets/img";
import darazLogo from "../../../assets/img/daraz-logo.png";
import Theme from "../../../constants/theme";

const CustomModal = ({
  open,
  setOpen,
  title,
  subTitle,
  headerImgClassName,
  headerTitleClassName,
  headerSubTitleClassName,
  children,
  closable = true,
  showHeaderLogo,
  showFooterLogo,
  onClickClose,
  width,
}) => {
  const theme = sessionStorage.getItem(Theme.KEY);

  return (
    <Modal
      {...MODAL_CONFIG}
      width={width ? width : MODAL_CONFIG.width}
      closable={closable}
      open={open}
      centered
      data-theme={sessionStorage.getItem(Theme.KEY)}
      closeIcon={
        <div className={"modal-close-icon"}>
          <Icon
            type={"close"}
            size={"md"}
            onClick={() => {
              setOpen(false);
              onClickClose && onClickClose();
            }}
            icon={<RiCloseLine />}
          />
        </div>
      }
      className="custom-modal notification-modal animate__animated">
      <div className="header-wrapper">
        {showHeaderLogo && (
          <>
            {theme ? (
              <div className="logo-img-wrapper">
                <img
                  className="animate_animated animate_fadeInDown daraz-logo"
                  src={darazLogo}
                  alt="Daraz online banking"
                />
              </div>
            ) : (
              <img
                className={`header-img animate__animated animate__fadeInDown ntb-logo ${headerImgClassName}`}
                src={ntbLogo}
                alt="NTB online banking"
              />
            )}
          </>
        )}
        <div className={`header-title ${headerTitleClassName}`}>{title}</div>
        <div className={`sub-title ${headerSubTitleClassName}`}>{subTitle}</div>
      </div>
      {children}

      {showFooterLogo && (
        <>
          {theme && (
            <>
              <div className="powered-by-title mt-4">Powered by</div>
              <img
                className="animate_animated animate_fadeInDown ntb-logo"
                src={ntbLogo}
                alt="NTB online banking"
                width={70}
              />
            </>
          )}
        </>
      )}
    </Modal>
  );
};
export default CustomModal;
